export var RumEventType;
(function (RumEventType) {
    RumEventType["ACTION"] = "action";
    RumEventType["ERROR"] = "error";
    RumEventType["LONG_TASK"] = "long_task";
    RumEventType["VIEW"] = "view";
    RumEventType["RESOURCE"] = "resource";
})(RumEventType || (RumEventType = {}));
export var ViewLoadingType;
(function (ViewLoadingType) {
    ViewLoadingType["INITIAL_LOAD"] = "initial_load";
    ViewLoadingType["ROUTE_CHANGE"] = "route_change";
})(ViewLoadingType || (ViewLoadingType = {}));
export var ActionType;
(function (ActionType) {
    ActionType["CLICK"] = "click";
    ActionType["CUSTOM"] = "custom";
})(ActionType || (ActionType = {}));
//# sourceMappingURL=rawRumEvent.types.js.map